<template>
  <div v-if="paymentMethods.length > 0" class="form__fieldset">
    <h3 class="text-[20px] mt-0 mb-[24px]">{{ in18['attribute_payment_method'] }}</h3>
    <div class="border border-[#C7C7C7] rounded-[8px] overflow-hidden relative">
      <template v-for="paymentMethod in paymentMethods" :key="paymentMethod.id">
        <label :for="paymentMethod.code" class="group p-[16px] flex gap-[12px] items-center border-b last:border-b-0 border-[#C7C7C7] w-full cursor-pointer">
          <input
                :id="paymentMethod.code"
                v-model="selectedPaymentMethod"
                :value="paymentMethod"
                class="appearance-none rounded-full h-[16px] w-[16px] border border-gray-300 bg-white checked:bg-lime-green-hover checked:border-lime-green focus:outline-none transition duration-150 ease-in-out group-hover:border-lime-green"
                name="payment-method"
                type="radio"
                @change="selectPaymentMethod()"
            >
          <div class="flex-1 cursor-pointer">
            <div class="text-[16px] font-light leading-[20px] ">{{ paymentMethod.title }}</div>
            <div class="radio-btn__text">{{ paymentMethod.description }}</div>
          </div>
          <picture>
            <source :srcset="paymentMethod.image.webp" type="image/webp">
            <img :alt="paymentMethod.title" :src="paymentMethod.image.source" class="h-[20px]">
          </picture>
        </label>
      </template>
      <!-- spinner -->
      <div v-if="inProgress" class="absolute z-10 inset-0 bg-white opacity-80 flex items-center justify-center">
          <svg
                  class="w-[32px] h-[32px] animate-spin stroke-lime-green"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 100 100"
                  preserveAspectRatio="xMidYMid"
              >
                  <circle
                  xmlns="http://www.w3.org/2000/svg"
                  cx="50"
                  cy="50"
                  fill="none"
                  stroke-width="10"
                  r="35"
                  stroke-dasharray="164.93361431346415 56.97787143782138"
                  transform="matrix(1,0,0,1,0,0)"
                  />
              </svg>
        </div>
    </div>
    <span v-if="errors['payment_method']" class=" text-[12px] text-[#eb2635]">*{{ errors['payment_method']?.[0]}}</span>

  </div>
</template>

<script>

import ValidationError from '../../features/ValidationError.vue';

export default {

  name: "CheckoutPayment",

  components: {
    'validation-error': ValidationError
  },

  props: {
    in18:       {
      type: Object,
    },
    errors:     {
      type: Object,
    },
    cart:       {
      type: Object,
    },
    inProgress: {
      type: Boolean,
    },
    selectedShippingMethod: {
      type: Object,
      default: null,
    }
  },

  data() {
    return {
      paymentMethods:        [],
      selectedPaymentMethod: null,
    }
  },

  emits: [
    'update-cart',
    'update-payment-method',
    'update-in-progress',
  ],


  created() {
    this.getPaymentMethods();
  },

    watch: {
        selectedShippingMethod: {
            handler: function () {
                this.getPaymentMethods();
            },
            deep: true,
        }
    },

  methods: {

    getPaymentMethods() {
      axios.get(`/api/payment?shipping_method_id=${this.selectedShippingMethod.id}`)
          .then((response) => {
            this.paymentMethods = response.data.paymentMethods;
          })
          .finally(() => {
              this.selectedPaymentMethod = this.cart.payment_method ? this.cart.payment_method : null;
              this.$emit('update-in-progress', false);
          })
    },

    selectPaymentMethod() {
      this.$emit('update-in-progress', true);

      return axios.post('/api/cart/payment/' + this.selectedPaymentMethod.id)
          .then((response) => {
            this.$emit('update-payment-method', this.selectedPaymentMethod);
            this.$emit('update-cart', response.data.cart);
            ga_add_payment_info_event(response.data.cart);
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
          });
    },
  },
};

</script>
